import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3.1111C12 2.4975 12.4975 2 13.1111 2h7.7777C21.5025 2 22 2.4975 22 3.1111v7.7778C22 11.5025 21.5025 12 20.8888 12h-2.2221v1.1111h-1.1112V12h-4.4444C12.4975 12 12 11.5025 12 10.8889V6.4445h-1.1111V5.3333H12zm1.4445 7.4444V5.9022l2.1428 1.5568-.8731 2.6872L17 8.4854l2.2858 1.6608-.8731-2.6872 2.1429-1.5568v4.6533Zm2.6824-4.7572h-2.6824V3.4445h3.4472zm1.7463 0-.7649-2.3538h3.4473v2.3538z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M4.2222 5.3333h1.1111v1.1112h-1.111Z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 4.2222c0-.6136.4975-1.111 1.1111-1.111h3.3334c.6136 0 1.111.4974 1.111 1.111v3.3333c0 .6137-.4974 1.1112-1.111 1.1112H3.111C2.4975 8.6667 2 8.1692 2 7.5555Zm1.4445 3V4.5555H6.111v2.6667z"
      clipRule="evenodd"
      key="2"
    />,
    <path fill="currentColor" d="M5.3333 12h-1.111v1.1111h1.111z" key="3" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10.8889c0-.6137.4975-1.1111 1.1111-1.1111h3.3334c.6136 0 1.111.4974 1.111 1.111v3.3334c0 .6137-.4974 1.1111-1.111 1.1111H3.111c-.6135 0-1.111-.4973-1.111-1.111Zm1.4445 3v-2.6667H6.111v2.6667z"
      clipRule="evenodd"
      key="4"
    />,
    <path
      fill="currentColor"
      d="M4.2222 18.6667h1.1111v1.1111h-1.111Z"
      key="5"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.1111 16.4445c-.6136 0-1.1111.4974-1.1111 1.111v3.3333C2 21.5025 2.4975 22 3.1111 22h3.3334c.6136 0 1.111-.4975 1.111-1.1112v-3.3333c0-.6136-.4974-1.111-1.111-1.111zm.3334 1.4444v2.6667H6.111v-2.6667z"
      clipRule="evenodd"
      key="6"
    />,
    <path fill="currentColor" d="M12 18.6667h-1.1111v1.1111H12z" key="7" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.7778 16.4445c-.6137 0-1.1111.4974-1.1111 1.111v3.3333c0 .6137.4974 1.1112 1.111 1.1112h3.3334c.6137 0 1.1111-.4975 1.1111-1.1112v-3.3333c0-.6136-.4974-1.111-1.111-1.111zm.3333 1.4444v2.6667h2.6667v-2.6667z"
      clipRule="evenodd"
      key="8"
    />,
    <path
      fill="currentColor"
      d="M18.6667 18.6667h-1.1112v1.1111h1.1112z"
      key="9"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.3333 17.5555c0-.6136.4975-1.111 1.1112-1.111h3.3333c.6136 0 1.111.4974 1.111 1.111v3.3333c0 .6137-.4974 1.1112-1.111 1.1112h-3.3333c-.6137 0-1.1112-.4975-1.1112-1.1112zm1.4445 3V17.889h2.6666v2.6667z"
      clipRule="evenodd"
      key="10"
    />,
    <path
      fill="currentColor"
      d="M10.8889 12H12v1.1111h-1.1111zM9.7778 3.1111h1.111v1.4444h-.7777v2.6667h.7778v1.4445H9.7778c-.6137 0-1.1111-.4975-1.1111-1.1112V4.2222c0-.6136.4974-1.111 1.111-1.111"
      key="11"
    />,
    <path
      fill="currentColor"
      d="M9.7778 9.7778h1.111v1.4444h-.7777v2.6667h2.6667v-.7778h1.4444v1.1111c0 .6137-.4974 1.1111-1.111 1.1111H9.7777c-.6137 0-1.1111-.4974-1.1111-1.111v-3.3334c0-.6137.4974-1.1111 1.111-1.1111m5.5557 4.4444v-1.111h1.4445v.7777h2.6666v-.7778h1.4444v1.1111c0 .6137-.4974 1.1111-1.111 1.1111h-3.3333c-.6137 0-1.1112-.4974-1.1112-1.111"
      key="12"
    />,
  ],
  'Basemaps',
);
